import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class NoteService { 
  baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient, 
  ) { }

  // https://dk90qm7un1jgu.cloudfront.net/api/notes/get/notes-types?uuid=2ecfc289-2c45-5fb0-9b16-cd97a6ce22a5
  // [
  //   {
  //     "note_type_id": 6,
  //     "note_type_name": "Alerte"
  //   },
  //   {
  //     "note_type_id": 1,
  //     "note_type_name": "Chronos"
  //   },
  //   {
  //     "note_type_id": 4,
  //     "note_type_name": "Inspection"
  //   },
  //   {
  //     "note_type_id": 5,
  //     "note_type_name": "Rappel"
  //   },
  //   {
  //     "note_type_id": 3,
  //     "note_type_name": "Rendez-Vous"
  //   },
  //   {
  //     "note_type_id": 2,
  //     "note_type_name": "Suivi-RV"
  //   }
  // ]
  getNotesTypes$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.notes}`;
    return this.http.get<any>(url + 'get/notes-types?uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/notes/get/notes-entities?uuid=2ecfc289-2c45-5fb0-9b16-cd97a6ce22a5
  // [
  //   {
  //     "note_entity_id": 4,
  //     "note_entity_name": "Accounts"
  //   },
  //   {
  //     "note_entity_id": 6,
  //     "note_entity_name": "Buildings"
  //   },
  //   {
  //     "note_entity_id": 1,
  //     "note_entity_name": "Clients"
  //   },
  //   {
  //     "note_entity_id": 3,
  //     "note_entity_name": "Contractors"
  //   },
  //   {
  //     "note_entity_id": 8,
  //     "note_entity_name": "Contracts"
  //   },
  //   {
  //     "note_entity_id": 9,
  //     "note_entity_name": "Invoices"
  //   },
  //   {
  //     "note_entity_id": 7,
  //     "note_entity_name": "Notes"
  //   },
  //   {
  //     "note_entity_id": 5,
  //     "note_entity_name": "Propositions"
  //   },
  //   {
  //     "note_entity_id": 2,
  //     "note_entity_name": "Submissions"
  //   }
  // ]
  getNotesEntities$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.notes}`;
    return this.http.get<any>(url + 'get/notes-entities?uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/notes/get/notes?uuid=2ecfc289-2c45-5fb0-9b16-cd97a6ce22a5
  getNotes$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.notes}`;
    return this.http.get<any>(url + 'get/notes?uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/notes/get/notes/type/2?uuid=2ecfc289-2c45-5fb0-9b16-cd97a6ce22a5
  getNotesOfType$(uuid: string, noteType: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.notes}`;
    return this.http.get<any>(url + 'get/notes/type/' + noteType + '?uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/notes/get/notes/type/2?uuid=2ecfc289-2c45-5fb0-9b16-cd97a6ce22a5
  getNotesOfSubmission$(uuid: string, noteType: number, entityId:number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.notes}`;
    return this.http.get<any>(url + 'get/submission/' + entityId + '/follow-ups' +'?uuid=' + uuid);
  }

  getFollowUps$(uuid: string, type: number, entity: number, startDate: string, endDate: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.notes}`;
    //return this.http.get<any>(url + 'get/notes/type/' + type + '/entity/' + entity + '/' + startDate + '/' + endDate + '?uuid=' + uuid);
    return this.http.get<any>(url + 'get/notes/calendar/follow-ups/' + startDate + '?uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/notes/1?uuid=2ecfc289-2c45-5fb0-9b16-cd97a6ce22a5
  uploadFiles$(uuid: string, type: number, files: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.notes}`;
    return this.http.post<any>(url + 'get/notes/' + type + '?uuid=' + uuid, files, httpOptions);
  }

  addSubmissionNote$(uuid: string, notes: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.notes}`;
    return this.http.post<any>(url + '?uuid=' + uuid, notes, httpOptions);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/notes/?uuid=5fc475e4-e930-501a-abfb-9ddcb9ee003c
  updateNote$(uuid: string, info: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.notes}`;
    //console.log('put notes', url + '?uuid=' + uuid, info, httpOptions);
    return this.http.put<any>(url + '?uuid=' + uuid, info, httpOptions);
  }

  deleteNote$(uuid: string, noteId: number, notes: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.notes}`;
    console.log(url + '/remove/'+ noteId +'?uuid=' + uuid, notes, httpOptions);
    
    //return this.http.get<any>(url + 'get/notes/type/3?uuid=' + uuid);

    return this.http.put<any>(url + '/remove/'+ noteId +'?uuid=' + uuid, notes, httpOptions);
  }

  getCalendrierVendeur$(uuid: string, salesId: number, startDate: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.notes}`;
    console.log(url + 'get/notes/calendar/' + salesId + '/appointments/' + startDate + '?uuid=' + uuid);
    return this.http.get<any>(url + 'get/notes/calendar/' + salesId + '/appointments/' + startDate + '?uuid=' + uuid);
  }

  getCalendrierJobs$(uuid: string, startDate: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.notes}`;
    console.log(url + 'get/notes/calendar/jobs/' + startDate + '?uuid=' + uuid);
    return this.http.get<any>(url + 'get/notes/calendar/jobs/' + startDate + '?uuid=' + uuid);
  }

  getCalendrierForeman$(uuid: string, startDate: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.notes}`;
    console.log(url + 'get/notes/calendar/jobs/' + startDate + '?uuid=' + uuid);
    return this.http.get<any>(url + 'get/notes/calendar/jobs/' + startDate + '?uuid=' + uuid);
  }
}
